import React, { useState } from 'react';
import { MenuItem } from '@mui/material';
import { Confirm, useRecordContext } from 'react-admin';
import { ApplicationStatus, PhoneScreenPendingStatus } from '../ApplicationStatusControl';

const PhoneScreenLabel = {
  resume_review: 'Advance to Phone Screen',
  phone_screen_scheduled: 'Reschedule Phone Screen',
  phone_screen_pending: 'Move to Phone Screen Scheduled (manual)',
  archived: 'Return to Phone Screen',
  rejected: 'Return to Phone Screen',
};

interface PhoneScreenPendingItemProps {
  updateApplicationStatus: (val: any) => void;
  currentApplicationStatus: ApplicationStatus;
}

const PhoneScreenPendingItem = ({
  updateApplicationStatus,
  currentApplicationStatus,
}: PhoneScreenPendingItemProps) => {
  const [open, setOpen] = useState(false);
  const record: any = useRecordContext();

  const latestActivePhoneScreeningId = (() => {
    const screenings = record?.professional_screenings || [];
    const filtered = screenings
      .filter(
        (s: any) =>
          s?.screening_type === 'phone' &&
          s?.reason === 'application' &&
          !s?.canceled_at &&
          !s?.no_show,
      )
      .sort(
        (a: any, b: any) =>
          (new Date(b.scheduled_time || 0) as any) - (new Date(a.scheduled_time || 0) as any),
      );
    return filtered[0]?.id;
  })();

  const handleConfirm = () => {
    if (currentApplicationStatus === 'phone_screen_scheduled' && latestActivePhoneScreeningId) {
      updateApplicationStatus({
        cancel_existing_screening_id: latestActivePhoneScreeningId,
        canceled_at: new Date().toISOString(),
        application_status: PhoneScreenPendingStatus,
      });
      return;
    }
    updateApplicationStatus({ application_status: PhoneScreenPendingStatus });
  };

  return (
    <>
      <MenuItem onClick={() => setOpen(true)}>
        {PhoneScreenLabel[currentApplicationStatus]}
      </MenuItem>
      <Confirm
        isOpen={open}
        title={`${PhoneScreenLabel[currentApplicationStatus]}?`}
        content={
          currentApplicationStatus === 'phone_screen_scheduled'
            ? 'This will cancel the currently scheduled phone screening before moving the application back to Phone Screen Pending. Continue?'
            : 'Are you sure you would like to proceed?'
        }
        onConfirm={handleConfirm}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default PhoneScreenPendingItem;
